enum FileCategories {
  STATEMENT = "STATEMENT",
  DOULA = "DOULA"
}

export type FileCategory = keyof typeof FileCategories

export default FileCategories
